import { render, staticRenderFns } from "./book_link.vue?vue&type=template&id=52cca1a3&scoped=true&"
import script from "./book_link.vue?vue&type=script&lang=js&"
export * from "./book_link.vue?vue&type=script&lang=js&"
import style0 from "./book_link.vue?vue&type=style&index=0&id=52cca1a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cca1a3",
  null
  
)

export default component.exports